import * as React from 'react';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import { EnhancedProps, } from './props';
import { Container, } from 'semantic-ui-react';

import './styles.css';

export default class UsersGrid extends React.Component<EnhancedProps> {

  static rowHeight: number = 75;

  constructor(props: EnhancedProps) {
    super(props);
    this.getRowHeight = this.getRowHeight.bind(this);
  }

  onGridSizeChanged(params: AgGridReactProps) {
    if (params.api) {
      params.api.sizeColumnsToFit();
    }
  }

  getRowHeight() {
    let height = UsersGrid.rowHeight;
    if (this.props.rowHeight) {
      height = this.props.rowHeight;
    }
    return height;
  }

  render() {
    return (
      <Container className="ag-theme-balham full-width">
        <AgGridReact
          gridOptions={this.props.options}
          columnDefs={this.props.columns}
          rowData={this.props.rows}
          context={this.props}
          enableFilter={this.props.enableFilter}
          onGridReady={this.props.onGridReady}
          onSelectionChanged={this.props.onSelectionChanged}
          onCellFocused={this.props.onCellFocused}
          onGridSizeChanged={this.onGridSizeChanged}
          onGridColumnsChanged={this.onGridSizeChanged}
          getRowHeight={this.getRowHeight}
        />
      </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/component.tsx